var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import IncomeOrderService from '../../api/IncomeOrderService';
import EHandleStatus from '../../enum/EHandleStatus';
import GLOBAL_VUE from '../../globalVue';
import AddDialog from './components/GoodAdd.vue';
import Header from './components/AddHeader.vue';
var initFormData = {
    order_type: 38,
    organ_id: '',
    depot_id: '',
    depot_admin: '',
    order_icomment: '',
};
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.order_id = '';
        _this.handleStatus = EHandleStatus.Add;
        _this.formData = __assign({}, initFormData);
        _this.data = [];
        _this.selections = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = IncomeOrderService.getInstance();
        if (this.order_id) {
            this.getDetail();
        }
    };
    default_1.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 370;
        }, 300);
    };
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.emptyData = function () {
        this.data = [];
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (type === 'order_detail_amount' || type === 'order_detail_uprice') {
            if (row.order_detail_amount) {
                row.order_detail_amount = Math.floor(Math.abs(row.order_detail_amount) * 10000) / 10000;
            }
            if (row.order_detail_uprice) {
                row.order_detail_uprice = Math.floor(Math.abs(row.order_detail_uprice) * 10000) / 10000;
            }
            if (row.order_detail_amount > 0 && row.order_detail_uprice >= 0) {
                row.order_detail_money = Math.floor(row.order_detail_amount * row.order_detail_uprice * 10000) / 10000;
                var order_detail_tax_rate = row.order_detail_tax_rate / 100;
                row.order_detail_tax_money =
                    Math.floor((row.order_detail_money / (1 + order_detail_tax_rate)) * order_detail_tax_rate * 10000) /
                        10000;
                row.order_detail_money_after =
                    Math.floor((row.order_detail_money - row.order_detail_tax_money) * 10000) / 10000;
            }
            else {
                row.order_detail_money = '';
                row.order_detail_tax_money = '';
            }
        }
    };
    default_1.prototype.save = function () {
        var _this = this;
        if (!this.checkSave())
            return;
        var params = __assign({}, this.formData, { data: JSON.stringify(this.data) });
        if (this.order_id) {
            params = Object.assign({}, params, { order_id: this.order_id });
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .save(params)
            .then(function (res) {
            loadingInstance.close();
            _this.$message.success(res.data.msg);
            setTimeout(function () {
                GLOBAL_VUE.$emit('closeTab', _this);
                if (_this.opener) {
                    _this.opener.getList();
                }
            }, 500);
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改退货单', '保存', '保存']);
            }
            else {
                window._czc.push(['_trackEvent', '添加退货单', '保存', '保存']);
            }
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    default_1.prototype.checkSave = function () {
        var _this = this;
        var flag = true;
        if (this.data && this.data.length) {
            this.data.map(function (row) {
                if (!row.order_detail_amount) {
                    flag = false;
                }
                if (!row.order_detail_uprice && row.order_detail_uprice !== 0 && _this.formData.order_type === 37) {
                    flag = false;
                }
            });
        }
        else {
            flag = false;
            this.$message.warning('请添加货品');
            return false;
        }
        if (!flag) {
            var msg = "\u6570\u91CF\u5927\u4E8E0" + (this.formData.order_type === 37 ? '，单价大于等于0。' : '');
            this.$message.warning(msg);
            return false;
        }
        return true;
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.order_id,
        };
        return this.service
            .getDetail(params)
            .then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.formData = Object.assign({}, _this.formData, {
                order_code: data.order_code,
                order_type_name: data.order_type_name,
                order_type: data.order_type,
                organ_id: data.organ_id,
                depot_id: data.depot_id,
                depot_admin: data.depot_admin,
                organ_name: data.organ_name,
                depot_name: data.depot_name,
                order_icomment: data.order_icomment,
            });
            _this.data = data.order_detail || [];
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.toAddGood = function () {
        var _this = this;
        if (this.handleStatus === EHandleStatus.Add && !this.formData.depot_id) {
            this.$message.warning('请选择仓库');
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                depot_id: this.formData.depot_id,
            },
        }, {
            title: '添加货品',
            width: 900,
            height: 550,
        });
        dialog.instance.$on('submit', function (res) {
            console.log('货品:%o', res);
            _this.data = res;
            _this.data.map(function (item) {
                if (!item.order_detail_uprice) {
                    item.order_detail_uprice = item.goods_price;
                }
            });
            _this.selections = [];
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改损溢单', '添加货品', '添加货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加损溢单', '添加货品', '添加货品']);
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning('请选择货品');
            return;
        }
        this.$confirm('请确认是否删除该货品', '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHandleStatus.Edit) {
                window._czc.push(['_trackEvent', '修改损溢单', '删除货品', '删除货品']);
            }
            else {
                window._czc.push(['_trackEvent', '添加损溢单', '删除货品', '删除货品']);
            }
        }, function (err) { });
    };
    default_1 = __decorate([
        Component({
            components: {
                'add-header': Header,
            },
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
